import { ApostleClassType } from '@apeiron/apostle'
import useFetchApostleClassesJson from '@src/hooks/json/useFetchApostleClassesJson'
import { toApostleClassType } from '@src/util/apeiron/apostle'
import { useCallback } from 'react'

const useApostleHelper = () => {
  const { data } = useFetchApostleClassesJson()

  const getApostleClassByType = useCallback(
    (classType?: ApostleClassType) => {
      return data?.find(apostleClass => apostleClass.type === classType)
    },
    [data]
  )

  const getApostleClassById = useCallback(
    (classId: number) => {
      const classType = toApostleClassType(classId)

      return getApostleClassByType(classType)
    },
    [getApostleClassByType]
  )

  return {
    getApostleClassById,
    getApostleClassByType
  }
}

export default useApostleHelper
